import {
  AfterViewInit,
  Component,
  ElementRef,
  EventEmitter,
  Input,
  Output,
} from '@angular/core';
import { WindowRefService } from '@callrail/looky/util';
import Clipboard from 'clipboard';
import { Subject, timer } from 'rxjs';
import { takeUntil } from 'rxjs/operators';

@Component({
  selector: 'ui-clipboard',
  templateUrl: './copy-clipboard.component.html',
  standalone: false,
})
export class CopyToClipboardComponent implements AfterViewInit {
  public clipboard: Clipboard;
  public window;
  public copiedToClipboard: boolean;
  private copyTimer = timer(5000);
  private readonly destroy = new Subject<void>();

  @Input() public clipboardRef: ElementRef;
  @Input() public clipboardId: string;
  @Input() public clipboardText: string;
  @Input() public copyText = 'Copy to clipboard';
  @Input() public copiedText = 'Copied to clipboard';

  /** Icon class(es) to show before the button label (e.g. 'icon-clipboard'). Only used when not projecting content via ng-content. */
  @Input() public iconClass: string;

  @Input() public btnClass: string;

  @Output() public clipboardSuccess: EventEmitter<any> = new EventEmitter();
  @Output() public clipboardError: EventEmitter<any> = new EventEmitter();

  constructor(
    private eltRef: ElementRef,
    public windowRef: WindowRefService
  ) {
    this.window = windowRef.nativeWindow();
  }

  public ngAfterViewInit() {
    if (this.clipboardText) {
      this.clipboard = new Clipboard(this.eltRef.nativeElement, {
        text: () => this.clipboardText,
      });
    } else {
      this.clipboard = new Clipboard(this.eltRef.nativeElement, {
        target: () => {
          return this.getCopyElement();
        },
      });
    }

    this.clipboard.on('success', (e) => {
      this.clipboardSuccess.emit(e);
      this.copiedToClipboard = true;
      this.copyTimer.pipe(takeUntil(this.destroy)).subscribe(() => {
        this.copiedToClipboard = false;
      });
    });

    this.clipboard.on('error', (e) => {
      this.clipboardError.emit(e);
    });
  }

  public ngOnDestroy() {
    if (this.clipboard) {
      this.clipboard.destroy();
    }
    this.destroy.next();
    this.destroy.complete();
  }

  private getCopyElement(): Element {
    if (this.clipboardRef) {
      return this.clipboardRef.nativeElement;
    } else {
      return this.window.document.getElementById(this.clipboardId);
    }
  }
}
